import { PortalModule } from '@angular/cdk/portal';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { I18nModule } from '@recruitee/i18n';

import { RtUICoreA11yModule } from './a11y/a11y.module';
import { RtUICoreOverlayModule } from './overlay/overlay.module';
import { RtUICoreRtlModule } from './rtl/rtl.module';

const MODULES = [
  CommonModule,
  I18nModule,
  RtUICoreA11yModule,
  RtUICoreOverlayModule,
  PortalModule,
  RtUICoreRtlModule,
];

@NgModule({
  imports: MODULES,
  exports: MODULES,
})
export class RtUICoreModule {}

export { KeyCode, ModifierKey, KeySymbol } from './keycode';

export * from './a11y/a11y.module';
export * from './overlay/overlay.module';
export * from './platform/platform';
export * from './portal/portal.module';
export * from './rtl/rtl.module';
